// @ vendors
const get = require('lodash/object/get');

// @ utilities
const { APIGet } = require('utilities/APIRequestHelper');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

// @ actions
const hirePaymentMethodActions = require('actions/hirePaymentMethod');
const hireCardCreditINE = require('actions/commons/hireCardCreditINE');

// @ constants
const actionTypes = require('constants/actionTypes');
const { CARD_MODIFY_LIMIT_MAX_TO_AUTHORIZE, CARD_PAYMENT_METHOD_FIXED, CARD_PAYMENT_METHOD_VARIABLE } = require('constants/index');
const { CREDIT_CARD_REVOLVING_PROCESS } = require('constants/flagBasedFeatures');
const { NOT_MAX_LIMIT } = require('constants/index');

function reset() {
    return {
        type: actionTypes.HIRE_CREDIT_LIMIT_RESET
    };
}

function validateLimitStep() {
    return {
        type: actionTypes.HIRE_CREDIT_LIMIT_VALIDATE_STEP
    };
}

function toggleModal(modalIsOpen) {
    return {
        type: actionTypes.HIRE_CREDIT_LIMIT_TOGGLE_MODAL,
        payload: {
            modalIsOpen
        }
    };
}

const hireCreditLimitRequest = () => ({
    type: actionTypes.HIRE_CREDIT_LIMIT_REQUEST
});

const hireCreditLimitSucess = (response, productType, productSubType, referenceStandard, defaultLimit) => {
    const marks = get(response, ['tarjetaList', 'tarjetaList', 0, 'limitesCreditoList', 'limitesCreditoList'], []);
    const maximumLimitAuthorize = get(response, 'limiteMaximoAutorizar') || false;

    return {
        type: actionTypes.HIRE_CREDIT_LIMIT_SUCCESS,
        payload: {
            defaultLimit,
            productType,
            productSubType,
            referenceStandard,
            marks,
            maxValue: marks[marks.length - 1] || 0,
            maxValueToAuthorize: Math.min(response.limiteMaximoAutorizar || 0, CARD_MODIFY_LIMIT_MAX_TO_AUTHORIZE),

        }
    };
};
const hireNewCreditLimitSucess = (response, productType, productSubType, referenceStandard, defaultLimit, newMaximumLimitAuthorize) => {
    const marks = get(response, ['tarjetaList', 'tarjetaList', 0, 'limitesCreditoList', 'limitesCreditoList'], []);
    const channel = get(response, ['tarjetaList', 'tarjetaList', 0, 'tarjetaRef', 'canal']);
    const maximumLimitAuthorize = get(response, 'limiteMaximoAutorizar') || false;
    const maximumLimitAuthorizeParse = parseInt(maximumLimitAuthorize, 10).toString();
    const index = marks.findIndex(mark => mark === maximumLimitAuthorizeParse);
    const slicedMarks = index !== -1 ? marks.slice(0, index + 1) : marks;
    const maxValue = maximumLimitAuthorize === NOT_MAX_LIMIT ? slicedMarks[slicedMarks.length - 1] : maximumLimitAuthorize ? maximumLimitAuthorizeParse : marks[marks.length - 1] || 0
    return {
        type: actionTypes.HIRE_CREDIT_LIMIT_SUCCESS,
        payload: {
            defaultLimit: maximumLimitAuthorize === NOT_MAX_LIMIT ? slicedMarks[0] : defaultLimit,
            productType,
            productSubType,
            referenceStandard,
            marks: maximumLimitAuthorize ? slicedMarks : marks,
            maxValue: maxValue,
            maxValueToAuthorize: Math.min(response.limiteMaximoAutorizar || 0, CARD_MODIFY_LIMIT_MAX_TO_AUTHORIZE),
            maximumLimitAuthorize,
            newMaximumLimitAuthorize,
            channel
        }
    };
};
const hireCreditLimitFailure = error => ({
    type: actionTypes.HIRE_CREDIT_LIMIT_FAILURE,
    payload: {
        error
    }
});

const getHireCreditLimit = (productType, productSubType, referenceStandard, defaultLimit, newCreditLimit, newMaximumLimitAuthorize, amount) => (dispatch, getState) => {
    if (!getState().hireCreditLimit.get('isFetching')) {
        const params = {
            header: {
                version: newCreditLimit && 2,
            },
            query: {
                tipo: productType,
                subtipo: productSubType,
                standard: referenceStandard,
                amount
            }
        };

        dispatch(hireCreditLimitRequest());
        return APIGet({
            dispatch,
            endpoint: 'hireCards',
            params
        })
            .then(response => {
                newCreditLimit ?
                    dispatch(hireNewCreditLimitSucess(response, productType, productSubType, referenceStandard, defaultLimit, newMaximumLimitAuthorize))
                    : dispatch(hireCreditLimitSucess(response, productType, productSubType, referenceStandard, defaultLimit));
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(hireCreditLimitFailure(response.error));
                } else {
                    throw response;
                }
            });

    }
};

function setHireCreditLimitValue(creditLimit, resetModalValue) {
    return {
        type: actionTypes.HIRE_CREDIT_LIMIT_SET,
        payload: {
            creditLimit,
            resetModalValue,
        }
    };
}
function setHireInitialCreditLimitValue(creditLimit) {
    return {
        type: actionTypes.HIRE_CREDIT_INITAL_LIMIT_SET,
        payload: {
            creditLimit
        }
    };
}
function setHireCreditLimitModalValue(creditLimitModalValue) {
    return {
        type: actionTypes.HIRE_CREDIT_LIMIT_SET_MODAL_VALUE,
        payload: {
            creditLimitModalValue
        }
    };
}

function resetCreditCardCheckboxCC() {
    return {
        type: actionTypes.HIRE_CARD_CREDIT_CARD_RESET_AGREEMENT_CHECKBOX_CC,
    }
};
function resetCreditCardDocumentsIneDir() {
    return {
        type: actionTypes.HIRE_CARD_CREDIT_CARD_RESET_DOCUMENTS_INE_DIR,
    }
};
function resetCardCreditOfficeRadioButton() {
    return {
        type: actionTypes.HIRE_CARD_CREDIT_CARD_CHECK_RADIO_BUTTON,
        payload: {
            check: undefined,
        }
    };
}

function resetPrintDocumentPolicy() {
    return {
        type: actionTypes.HIRE_CARD_CREDIT_CARD_PRINT_DOCUMENT,
        payload: {
            value: false,
        }
    };
}
const validateStep = () => (dispatch, getState) => {
    const immHireCreditLimit = getState().hireCreditLimit;
    const creditLimit = immHireCreditLimit.get('creditLimit');
    const initialCreditLimit = immHireCreditLimit.get('initialCreditLimit');
    if (Number(creditLimit) !== Number(initialCreditLimit)) {
        dispatch(setHireInitialCreditLimitValue(creditLimit));
        dispatch(hireCardCreditINE.getInitCardsDocuments());
    }

    dispatch(validateLimitStep());

};
const setHireCreditLimit = (creditLimit, resetModalValue = false) => (dispatch, getState) => {
    const immHirePaymentMethod = getState().hirePaymentMethod;
    const immHireCreditLimit = getState().hireCreditLimit;
    const paymentMethodType = immHirePaymentMethod.get('type');
    const paymentMethodValue = immHirePaymentMethod.get('value');
    const showIneAndRevolving = getState().flagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);

    //if comes from modal, skip reseting payment method, (the modal returns resetModalValue = true)
    if (!resetModalValue || (showIneAndRevolving && !immHireCreditLimit.get('modalIsOpen'))) {
        if (paymentMethodType === CARD_PAYMENT_METHOD_FIXED && paymentMethodValue !== '' ||
            (showIneAndRevolving && paymentMethodType === CARD_PAYMENT_METHOD_VARIABLE)
        ) {
            dispatch(hirePaymentMethodActions.setValue(''));
        }
    }

    dispatch(setHireCreditLimitValue(creditLimit, resetModalValue));
    dispatch(resetCreditCardCheckboxCC());
    dispatch(resetCreditCardDocumentsIneDir());

    if (isPrintOfficeMode()) {
        dispatch(resetPrintDocumentPolicy());
        dispatch(resetCardCreditOfficeRadioButton());
    }
};

module.exports = {
    getHireCreditLimit,
    setHireCreditLimitModalValue,
    reset,
    setHireCreditLimit,
    toggleModal,
    validateStep,
    resetCreditCardCheckboxCC
};
